import BatchQuery from "./BatchQuery.json";
import ERC20 from "./ERC20.json";
import XSwapRouter from "./XSwapRouter.json";
import XSwapTokenFeeDistributor from "./XSwapTokenFeeDistributor.json";
import CustomXSwapRouter from "./CustomXSwapRouter.json";
import StakingStableAPR from "./StakingStableAPR.json";

export const BatchQueryAbi = BatchQuery;
export const ERC20Abi = ERC20;
export const XSwapRouterAbi = XSwapRouter;
export const XSwapTokenFeeDistributorAbi = XSwapTokenFeeDistributor;
export const CustomXSwapRouterAbi = CustomXSwapRouter;
export const StakingStableAPRAbi = StakingStableAPR;
